// Internal link removal
navLinkRemoval = function(e) {
  e.preventDefault();
  window.location.href = $(this).attr('data-url');
  console.log($(this).attr('data-url'));
}

var navLinks = document.getElementsByClassName('no-href');
for (var i=0; i < navLinks.length; i++) {
  navLinks.item(i).onclick = navLinkRemoval;
}

document.addEventListener('quizKitAddToCartSuccess', function (e) {
  const customAddToCart = new CustomEvent("product:added", {
    bubbles: true,
    detail: { quantity: 1 }
  });
  
  document.dispatchEvent(customAddToCart)
}, false);

// Accordion
(() => {
  document.addEventListener(
    'toggle',
    (event) => {
      // #region agent log
      fetch('http://127.0.0.1:7242/ingest/3f62fe03-8804-473e-946f-9fb90e707fb0',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({location:'custom.js:26',message:'Toggle event fired',data:{targetTagName:event.target.tagName,isDetails:event.target instanceof HTMLDetailsElement,isOpen:event.target.open,eventPhase:event.eventPhase},timestamp:Date.now(),sessionId:'debug-session',runId:'run1',hypothesisId:'A'})}).catch(()=>{});
      // #endregion
      const opened = event.target;
      if (!(opened instanceof HTMLDetailsElement)) return;
      if (!opened.open) return;

      const allOpen = document.querySelectorAll('details[open]');
      // #region agent log
      fetch('http://127.0.0.1:7242/ingest/3f62fe03-8804-473e-946f-9fb90e707fb0',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({location:'custom.js:31',message:'Found open details elements',data:{openedId:opened.id||'no-id',openedText:opened.querySelector('summary')?.textContent?.trim()||'no-text',allOpenCount:allOpen.length,allOpenIds:Array.from(allOpen).map(d=>({id:d.id||'no-id',text:d.querySelector('summary')?.textContent?.trim()||'no-text',isAncestor:opened.contains(d),isDescendant:d.contains(opened)})),isNested:Array.from(allOpen).some(d=>d!==opened&&(opened.contains(d)||d.contains(opened)))},timestamp:Date.now(),sessionId:'debug-session',runId:'run1',hypothesisId:'A'})}).catch(()=>{});
      // #endregion
      document.querySelectorAll('details[open]').forEach((d) => {
        // Don't close the opened element itself, and don't close parent accordions (elements that contain the opened one)
        if (d !== opened && !d.contains(opened)) {
          // #region agent log
          fetch('http://127.0.0.1:7242/ingest/3f62fe03-8804-473e-946f-9fb90e707fb0',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({location:'custom.js:39',message:'Closing details element',data:{closingId:d.id||'no-id',closingText:d.querySelector('summary')?.textContent?.trim()||'no-text',openedId:opened.id||'no-id',openedText:opened.querySelector('summary')?.textContent?.trim()||'no-text',isParent:opened.contains(d),isChild:d.contains(opened),relationship:opened.contains(d)?'parent-closing-child':d.contains(opened)?'child-closing-parent':'sibling'},timestamp:Date.now(),sessionId:'debug-session',runId:'post-fix'})}).catch(()=>{});
          // #endregion
          d.open = false;
        } else if (d !== opened && d.contains(opened)) {
          // #region agent log
          fetch('http://127.0.0.1:7242/ingest/3f62fe03-8804-473e-946f-9fb90e707fb0',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({location:'custom.js:44',message:'Preserving parent accordion',data:{parentId:d.id||'no-id',parentText:d.querySelector('summary')?.textContent?.trim()||'no-text',childId:opened.id||'no-id',childText:opened.querySelector('summary')?.textContent?.trim()||'no-text'},timestamp:Date.now(),sessionId:'debug-session',runId:'post-fix'})}).catch(()=>{});
          // #endregion
        }
      });
    },
    true
  );
})();